import { mapState, mapActions } from 'vuex'
import { formatPrizePoints, getSlugFromRoute } from '../../../../assets/js/Utils'

export default {
  props: { value: Object },

  data: () => ({
    loading: false,
    qtd: 1,
    images: []
  }),

  watch: {
    value() {
      this.loadImages()
    }
  },

  created() {
    this.loadImages()
  },

  methods: {
    ...mapActions(["actionGetBalanceCliente"]),

    async loadImages() {
      this.images = [this.value.imagemPrincipal]
      const resp = await this.MODULOS.prize.getPrize(this.value.id_produto)
      resp.prize.imagensAdicionais.forEach(e => e != null && this.images.push(e))
    },

    async redemptionPrize() {
      if (!this.user) {
        return
      }

      this.loading = true

      const resp = await this.MODULOS.redemption.redemptionPrize({ quantidade: this.qtd, id_premio: this.value.id_produto })

      if (resp.status == 200) {
        this.actionGetBalanceCliente()
        this.$router.push({ path: `/${getSlugFromRoute(this.$route.path)}/voucher/${resp.resgate.id_pedido}` })
        this.$toasted.global.success({ msg: "Prêmio resgatado! Imprima e efetue a troca!" })
      }
      if(resp.status == 500){
        this.$toasted.global.error({ msg: resp.mensagem })
      }

      this.loading = false
    },

    formatPrizePoints,

    prizeIsUnavailable(prize) {
      const unavailableStatus = 2;
      const prizeCategoryNotAllowed = this.prizeCategoryNotAllowed(prize);
      return prize.estoque === 0 || prize.status == unavailableStatus || prizeCategoryNotAllowed;
    },

    prizeCategoryNotAllowed(prize) {
      const contractedResource = this.establishment.contractedResources?.includes("premios_por_categoria_cliente__");
      const configEnabled = this.establishment.configuracoes?.premios_por_categoria_cliente;
      const prizeCategoryNotAllowed = !this.user.allowedPrizeCategories?.includes(prize.categoria);
      return contractedResource && configEnabled && prizeCategoryNotAllowed;
    }
  },

  computed: {
    ...mapState(["user", "establishment"]),
  },
};